import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import LocationalState from "../LocationalState";
import {RoadObjectInfo} from "./RoadObjectInfo";
import {RoadSegmentInfo} from "./RoadSegmentInfo";
import {LocationalTool} from "./LocationalTool";
import {AnchorsTool} from "./AnchorsTool";
import {ApproveLocationalsTool} from "./ApproveLocationalsTool";
import {LocalizeManuallyTool} from "./LocalizeManuallyTool";

interface TagProps {
}

interface DispatchProps {
}

interface StateProps {
    useSkrivLocationals: boolean;
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        useSkrivLocationals: selectors.useSkrivLocationals(state)
    };
};

const mapDispatchToProps: DispatchProps = ({});

class Component extends React.Component<Props, {}> {
    render() {
        return (
            <div id="locationalToolBox">
                <div className={"toolSection"}>
                    <RoadObjectInfo/>
                </div>
                <div className={"toolSection"}>
                    <RoadSegmentInfo/>
                </div>
                <div className={"toolSection"}>
                    {this.props.useSkrivLocationals && <LocalizeManuallyTool/> }
                    {!this.props.useSkrivLocationals && <AnchorsTool/> }
                </div>
                <div className={"toolSection"}>
                    <LocationalTool/>
                </div>
                <div className={"toolSection"}>
                    <ApproveLocationalsTool />
                </div>

            </div>
        );
    }
}

export const LocationalToolBox = connect(mapStateToProps, mapDispatchToProps)(Component);